import { useEffect, useState } from "react";
import { useAuthContext } from "hooks/useAuthContext";
import { useSupervisorContext } from "hooks/useSupervisorContext";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import EditSupervisorPopup from "../components/editSupervisorPopup";
import { API_URL } from "../../../../config";

export default function useData() {
  const { user } = useAuthContext();
  const { supervisors, dispatch } = useSupervisorContext();
  const [loading, setLoading] = useState(true);
  const [currentAcademicYear, setCurrentAcademicYear] = useState("");

  useEffect(() => {
    const getAcademicYear = async () => {
      try {
        const response = await fetch(`${API_URL}/academicyears/current`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });

        const academicYearJson = await response.json();
        if (response.ok) {
          setCurrentAcademicYear(academicYearJson.id);
        } else {
          throw new Error("Failed to fetch academic year");
        }
      } catch (error) {
        console.error("Error fetching academic year:", error);
      }
    };

    getAcademicYear();
  }, [user]);

  const fetchSupervisors = async () => {
    try {
      const response = await fetch(`${API_URL}/supervisors/getsupervisors`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });

      const supervisorsJson = await response.json();

      if (response.ok) {
        dispatch({
          type: "GET_SUPERVISORS",
          payload: supervisorsJson,
        });
      } else {
        throw new Error("Failed to fetch supervisors");
      }
    } catch (error) {
      console.error("Error fetching supervisors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchSupervisors();
    }
  }, [user, dispatch]);

  if (loading || !currentAcademicYear) {
    return {
      columns: [],
      rows: [],
    };
  }

  const rows = supervisors
    ? supervisors.map((supervisor) => {
        const currentAvailability = supervisor.Availabilities?.find(
          (availability) => availability.academicYearId === currentAcademicYear
        );

        const isAvailable = currentAvailability?.available || false;

        return {
          name: `${supervisor.first_name} ${supervisor.last_name}`,
          email: supervisor.email,
          status: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={isAvailable ? "Available" : "Not Available"}
                color={isAvailable ? "success" : "dark"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          edit: (
            <EditSupervisorPopup
              fetchSupervisors={fetchSupervisors}
              supervisor={supervisor}
              isAvailable={isAvailable}
            />
          ),
        };
      })
    : [];

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "center" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Edit", accessor: "edit", align: "center" },
    ],
    rows,
  };
}
